import React from "react";
import FromToDatePicker from "./FromToDatePicker";

const Index = (props: any) => {
  return <FromToDatePicker {...props} />;
};

export default Index;
